<div class="row no-gutters col-12 d-flex align-items-center justify-content-end pr-0">
  <button class="btn btn-light" (click)="onConfirmClick()" [matTooltip]="'Close'">
    <i class="fa fa-close"></i>
  </button>
</div>
<form [formGroup]="regiForm" class="col-12 m-auto justify-content-center p-0">
  <div class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center">
    <div class="col-xl-12 col-md-12 col-sm-12 col-12 text-normal p-0">
      First Name
    </div>
    <mat-form-field appearance="outline" style="margin-top: -8px;"
      class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center text-normal p-0">
      <input formControlName="firstName" name="firstName" matInput #firstName maxlength="20">
      <mat-hint align="end">{{firstName.value.length}} / 16</mat-hint>
    </mat-form-field>
  </div>
  <div class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center">
    <div class="col-xl-12 col-md-12 col-sm-12 col-12 text-normal p-0">
      Last Name
    </div>
    <mat-form-field appearance="outline" style="margin-top: -8px;"
      class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center text-normal p-0">
      <input formControlName="lastName" name="lastName" matInput #lastName maxlength="20">
      <mat-hint align="end">{{lastName.value.length}} / 20</mat-hint>
    </mat-form-field>
  </div>
  <div class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center" style="display: flex; align-items: center;">
    <div style="flex-grow: 1; border-top: 1px solid #CCC;"></div>
    <span style="padding: 0 10px;">or</span>
    <div style="flex-grow: 1; border-top: 1px solid #CCC;"></div>
  </div>
  <div class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center">
    <div class="col-xl-12 col-md-12 col-sm-12 col-12 text-normal p-0">
      Email
    </div>
    <mat-form-field appearance="outline" style="margin-top: -8px;"
      class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center text-normal p-0">
      <input formControlName="email" name="email" matInput #email maxlength="50">
      <mat-hint align="end">{{email.value.length}} / 50</mat-hint>
    </mat-form-field>
  </div>
  <div class="row no-gutters col-12 d-flex align-items-center justify-content-center">
    <button class="btn btn-primary button col-xl-6 col-md-6 col-sm-12 text-normal"
    (click)="submitForm()">
      <span>
        Search SSO
      </span>
    </button>
  </div>
  <br>
  <div class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center" *ngIf="listSSO.length">
    <div class="col-xl-12 col-md-12 col-sm-12 col-12 text-normal p-0">
      SSO ID
    </div>
    <mat-form-field appearance="outline" style="margin-top: -8px;"
      class="col-xl-12 col-md-12 col-sm-12 col-12 justify-content-center text-normal p-0">
      <mat-select formControlName="ssoID" (selectionChange)="selectSSOID($event)">
        <mat-option *ngFor="let item of listSSO" [value]="item">
          {{item.fullName}} ({{item.sso}})
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>